import axios from "axios";
import { useEffect, useState } from "react";
import AlertComponent from "../../components/AlertComponent";
import Loading from "../../components/Loading";

export default function AlterarSenha() {
  const [loading, setLoading] = useState(false);

  const [form, setForm] = useState({
    senhaAtual: "",
    novaSenha: "",
    confirmarNovaSenha: "",
  });

  const handleChange = (e) => {
    const { name, value } = e.target;
    setForm((prev) => ({ ...prev, [name]: value }));
  };

  const validar = () => {
    if (!form.senhaAtual?.trim()) {
      AlertComponent("Erro", "Informe a senha atual.", { icon: "error" });
      return false;
    }

    if (!form.novaSenha?.trim()) {
      AlertComponent("Erro", "Informe a nova senha.", { icon: "error" });
      return false;
    }

    if (form.novaSenha.length < 6) {
      AlertComponent("Erro", "A nova senha deve ter pelo menos 6 caracteres.", { icon: "error" });
      return false;
    }

    if (!form.confirmarNovaSenha?.trim()) {
      AlertComponent("Erro", "Confirme a nova senha.", { icon: "error" });
      return false;
    }

    if (form.novaSenha !== form.confirmarNovaSenha) {
      AlertComponent("Erro", "A confirmação não confere com a nova senha.", { icon: "error" });
      return false;
    }

    if (form.senhaAtual === form.novaSenha) {
      AlertComponent("Erro", "A nova senha não pode ser igual à senha atual.", { icon: "error" });
      return false;
    }

    return true;
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (!validar()) return;

    setLoading(true);
    try {
      // Se você já tem interceptor setando Authorization, ok.
      // Se não tiver, você pode descomentar abaixo:
      // const jwt = localStorage.getItem("jwt");
      // axios.defaults.headers.common["Authorization"] = `Bearer ${jwt}`;

      await axios.put(`${process.env.REACT_APP_API}/usuario/senha`, {
        senhaAtual: form.senhaAtual,
        novaSenha: form.novaSenha,
      });

      AlertComponent("Sucesso", "Senha alterada com sucesso!", { icon: "success" });

      setForm({
        senhaAtual: "",
        novaSenha: "",
        confirmarNovaSenha: "",
      });
    } catch (err) {
      console.error(err);
      AlertComponent(
        "Erro",
        err?.response?.data?.message ?? "Erro ao alterar senha",
        { icon: "error" }
      );
    } finally {
      setLoading(false);
    }
  };

  if (loading) return <Loading />;

  return (
    <div className="w-full">
      {/* HEADER */}
      <div className="mb-8">
        <h1 className="text-2xl font-semibold text-slate-800">Alterar senha</h1>
        <p className="text-sm text-slate-500">
          Informe sua senha atual e defina uma nova senha.
        </p>
      </div>

      <form onSubmit={handleSubmit} className="space-y-6">
        <div className="bg-white p-8 rounded-xl shadow border">
          <h2 className="text-lg font-medium text-gray-800 mb-6">Dados</h2>

          <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
            <div className="md:col-span-2">
              <label className="block text-sm font-medium text-gray-700 mb-1">
                Senha atual *
              </label>
              <input
                type="password"
                name="senhaAtual"
                value={form.senhaAtual}
                onChange={handleChange}
                className="w-full p-3 border rounded-md focus:outline-none focus:ring-2 focus:ring-slate-300"
                placeholder="••••••••"
                required
                disabled={loading}
                autoComplete="current-password"
              />
            </div>

            <div>
              <label className="block text-sm font-medium text-gray-700 mb-1">
                Nova senha *
              </label>
              <input
                type="password"
                name="novaSenha"
                value={form.novaSenha}
                onChange={handleChange}
                className="w-full p-3 border rounded-md focus:outline-none focus:ring-2 focus:ring-slate-300"
                placeholder="Mínimo 6 caracteres"
                required
                minLength={6}
                disabled={loading}
                autoComplete="new-password"
              />
            </div>

            <div>
              <label className="block text-sm font-medium text-gray-700 mb-1">
                Confirmar nova senha *
              </label>
              <input
                type="password"
                name="confirmarNovaSenha"
                value={form.confirmarNovaSenha}
                onChange={handleChange}
                className="w-full p-3 border rounded-md focus:outline-none focus:ring-2 focus:ring-slate-300"
                placeholder="Repita a nova senha"
                required
                minLength={6}
                disabled={loading}
                autoComplete="new-password"
              />
            </div>
          </div>
        </div>

        {/* AÇÕES */}
        <div className="flex justify-end gap-3 border-t pt-6">
          <button
            type="submit"
            className="px-6 py-2 rounded-md bg-slate-900 text-white hover:bg-slate-800 disabled:opacity-50"
            disabled={loading}
          >
            {loading ? "Salvando..." : "Alterar senha"}
          </button>
        </div>
      </form>
    </div>
  );
}